var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.39941H2.33333H13",
    stroke: "#FF0000",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 3.4V11.8C11.6666 12.1183 11.5261 12.4235 11.2761 12.6485C11.026 12.8736 10.6869 13 10.3333 13H3.66659C3.31296 13 2.97382 12.8736 2.72378 12.6485C2.47373 12.4235 2.33325 12.1183 2.33325 11.8V3.4M4.33325 3.4V2.2C4.33325 1.88174 4.47373 1.57652 4.72378 1.35147C4.97383 1.12643 5.31296 1 5.66659 1H8.33325C8.68687 1 9.02601 1.12643 9.27606 1.35147C9.52611 1.57652 9.66659 1.88174 9.66659 2.2V3.4",
    stroke: "#FF0000",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ef3a83e7cf95bfeacd417ea1ce856142.svg";
export { ForwardRef as ReactComponent };